'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
const CricketVoteLevel = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-center mb-6"><p className="text-18-tamil-700 text-center text-1B1B1B pb-12 px-5 leading-[1.5] line-clamp-5">எலிமினேட்டர் ரசிகர் கருத்துக்கணிப்பு கேள்வி 3: அவர்களின் வெளிநாட்டு பேட்டிங்கை அதிகம் சார்ந்திருப்பவர்கள் யார்?</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-y-0 left-0 bg-FFDB59 rounded-l-[4px]" style={{
      width: "73%"
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-FFFFFF rounded-lg overflow-hidden"><div className="relative">{t1}<div className="relative flex items-center justify-between px-4 py-3"><div className="text-14-tamil-600 text-1B1B1B line-clamp-1 z-10">லக்னோ சூப்பர் ஜெயண்ட்ஸ்</div><div className="text-14-tamil-600 text-1B1B1B line-clamp-1 z-10">73%</div></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={"absolute inset-y-0 left-0 bg-FFDB59 rounded-l-[4px]\n"} style={{
      width: "27%"
    }} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-ECEEF3 border-DCDCDC border-1 py-8 px-4 max-w-md mx-auto">{t0}<div className="space-y-4">{t2}<div className="bg-FFFFFF rounded-lg overflow-hidden"><div className="relative">{t3}<div className="relative flex items-center justify-between px-4 py-3"><div className="text-14-tamil-600 text-1B1B1B line-clamp-1 z-10">மும்பை இந்தியன்ஸ்</div><div className="text-14-tamil-600 text-1B1B1B line-clamp-1 z-10">27%</div></div></div></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default CricketVoteLevel;